// Used to temporarily change the position number for lines on calculation page
// Happens in scenario when we need to sort single position with not multiple of ten number
// or can when we use automatically sorting button for all offers lines
export const OFFSET_POSITION_NUMBER_CALC = 200000;
